module.exports = __webpack_public_path__ + "static/media/footer-cover3.57540e46.jpeg";